import { render, staticRenderFns } from "./YesNoChoice.vue?vue&type=template&id=73a5ae13&scoped=true&"
import script from "./YesNoChoice.vue?vue&type=script&lang=js&"
export * from "./YesNoChoice.vue?vue&type=script&lang=js&"
import style0 from "./YesNoChoice.vue?vue&type=style&index=0&id=73a5ae13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a5ae13",
  null
  
)

export default component.exports